const DownloadIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    width='107'
    height='122'
    viewBox='0 0 107 122'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M43.1813 0.0625V52.994L31.0756 40.3495L18.4899 52.3942L39.4289 74.2651L37.5323 75.9764L49.2066 88.906L87.9701 53.921L76.2957 40.9915L60.6445 55.1168V0.0625H43.1813ZM0.265625 75.9957L0.663367 112.692L0.572443 120.83L100.6 121.938L100.626 119.608L104.31 119.771L106.194 77.4205L88.7131 76.6489L87.4798 104.364L18.0641 103.596L17.7628 75.8072L0.265625 75.9957Z'
      fill='currentColor'
    />
  </svg>
);

export default DownloadIcon;
